<div class="modal">
    <div class="header">
        <h1 class="title" translate>{{ref.data.confirmTitle}}</h1>
    </div>
    <div class="body">
        <ng-container *ngIf="(processing$ |async)">
            <div class="loading-container">
                <div class="loading-spinner-grey"></div>
            </div>
        </ng-container>
        <ng-container *ngIf="!(processing$ |async)">
            <div class="section">
                <div class="modal-info-add-image-video-body-container-main">
                    <div class="modal-info-add-image-video-main-content" translate>
                        {{ref.data.confirmHint}}
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
    <div class="footer">
        <button class="btn-new white" type="submit" (click)="closeModal()" [disabled]="(processing$ | async)"
            translate>PREMIUM_ADMIN_MEMBER_MODAL_ADD_GROUP_BUTTON_LABEL_CANCEL</button>
        <button class="btn-new red" (click)="confirmAction()" translate [disabled]="(processing$ |async)">{{ref.data.confirmButton}}</button>
    </div>
</div>